import React from "react";
import { Link } from "react-router-dom";
import heroimage from "../assets/hero-img.webp";
import greenStar from "../assets/shapes/green-star.png";
import grayStar from "../assets/shapes/gray-star.png";
import greenArrow from "../assets/shapes/green-arrow.png";
import { scrollToTop } from "../constent/helper";

export const HeroSection = () => {
  return (
    <section className="relative w-full bg-white">
      {/* Background split */}
      <div className="absolute inset-0 flex flex-col-reverse md:flex-row">
        <div className="bg-white md:w-1/2 w-full md:h-auto sm:h-1/2 h-[60%]" />
        <div className="bg-[#0C2A2E] md:w-1/2 w-full md:h-auto sm:h-1/2 h-[40%]" />
      </div>

      {/* Stars */}
      <img
        src={grayStar}
        alt=""
        className="absolute w-14 h-14 right-0 top-[25%] z-10"
      />

      {/* Content */}
      <div className="relative flex flex-col-reverse md:flex-row items-center justify-center md:gap-10 max-w-[1380px] mx-auto px-4 md:px-8 pt-28 pb-10 md:pt-24 md:pb-0 lg:pt-32 lg:pb-0 xl:pt-40 xl:pb-0">
        {/* Left text block */}
        <div className="md:w-1/2 w-full flex flex-col justify-center text-left space-y-5 md:space-y-6">
          <h1 className="text-4xl md:text-5xl xl:text-[56px] font-bold font-roboto !leading-[140%] md:mt-auto mt-12">
            Donate with Trust, Change Lives with KWF
          </h1>
          <p className="text-lg text-gray font-roboto max-w-lg">
            Join hands with one of Pakistan's most trusted non-profit
            organizations dedicated to empowering and uplifting the lives of
            those in need.
          </p>
          <div>
            <Link
              to="/donation"
              onClick={scrollToTop}
              className="primary-button"
            >
              DONATE NOW
            </Link>
          </div>
        </div>

        {/* Right image block */}
        <div className=" md:w-1/2 w-full h-full relative">
            <div className="flex justify-center items-end h-full">
              <div className="sm:px-4 px-[8px] md:px-8 flex justify-center w-max h-max relative md:bottom-[-40px]">
                <img
                  src={greenArrow}
                  className="w-6 h-6 md:block hidden absolute top-[-5%] left-[2%]"
                  alt=""
                />
                <img
                  src={heroimage}
                  className="w-full max-w-full z-20 object-cover"
                  alt="donate image"
                  loading="lazy"
                />
                    <img
                src={greenStar}
                className="w-14 h-14 z-10 absolute right-[2%] bottom-[-7%]"
                alt=""
              />
              </div>
          
            </div>
          </div>
      </div>
    </section>
  );
};
